module.exports = __webpack_public_path__ + "static/media/hulk-profile.dde4610a.jpg";